export default __webpack_public_path__ + "static/media/robot_intro.a7c274d8.gif";